var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.08,
    height: 21.076,
    viewBox: "0 0 21.08 21.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M10.537,7.372a5.4,5.4,0,1,0,5.4,5.4A5.395,5.395,0,0,0,10.537,7.372Zm0,8.917a3.513,3.513,0,1,1,3.513-3.513A3.519,3.519,0,0,1,10.537,16.288Zm6.885-9.138a1.26,1.26,0,1,1-1.26-1.26A1.257,1.257,0,0,1,17.422,7.151ZM21,8.43a6.237,6.237,0,0,0-1.7-4.416,6.278,6.278,0,0,0-4.416-1.7c-1.74-.1-6.955-.1-8.7,0a6.269,6.269,0,0,0-4.416,1.7,6.258,6.258,0,0,0-1.7,4.416c-.1,1.74-.1,6.955,0,8.7a6.237,6.237,0,0,0,1.7,4.416,6.286,6.286,0,0,0,4.416,1.7c1.74.1,6.955.1,8.7,0a6.237,6.237,0,0,0,4.416-1.7A6.278,6.278,0,0,0,21,17.121c.1-1.74.1-6.951,0-8.691ZM18.753,18.988a3.557,3.557,0,0,1-2,2c-1.387.55-4.679.423-6.212.423s-4.83.122-6.212-.423a3.557,3.557,0,0,1-2-2C1.771,17.6,1.9,14.309,1.9,12.775s-.122-4.83.423-6.212a3.557,3.557,0,0,1,2-2c1.387-.55,4.679-.423,6.212-.423s4.83-.122,6.212.423a3.557,3.557,0,0,1,2,2c.55,1.387.423,4.679.423,6.212S19.3,17.605,18.753,18.988Z",
    transform: "translate(0.005 -2.237)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeInstagram);
export default __webpack_public_path__ + "static/media/Icon awesome-instagram.43e269c53ca7804f88a7bc474cff95d3.svg";
export { ForwardRef as ReactComponent };